module.exports = "<svg data-name=\"Layer 1\" viewBox=\"0 0 14 14\"><path d=\"M5.75 12.75a1.5 1.5 0 0 1-1.06-.44l-4-4a1.5 1.5 0 0 1 2.12-2.12L5.6 8.977l5.459-7.14A1.5 1.5 0 1 1 13.44 3.66l-6.5 8.501a1.502 1.502 0 0 1-1.092.586 1.708 1.708 0 0 1-.099.003z\" data-name=\"Path 4\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/check.svg
// module id = 241
// module chunks = 1